// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"LinkInput__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LinkInput/LinkInput.scss
 ** module id = 921
 ** module chunks = 1
 **/